/* eslint-disable no-param-reassign, max-len, consistent-return, no-use-before-define, prefer-destructuring */
/* eslint-disable no-alert */

/* global FB */
import '../css/reset.css';
import '../css/common.css';
import {
  requestPOST,
  requestGET,
  getQuerystring,
  setJWTTokenData,
  setJWTUserData,
  OLD_API_URL,
  clearLocalStorageItem,
  getClientID,
  getInfoOfDeviceOS,
  validateEmail,
  appendQueryObject,
} from './common-es6';
import { webkitBridgeWebviewFirebaseUserProperty } from '../../components/utils/locationMovement';

// DOM 요소들
const popupJoin = document.getElementById('popupJoin');
const popupLoginEmail = document.getElementById('popupLoginEmail');
const popupFindPw = document.getElementById('popupFindPw');
const popupFindPwSuccessEmail = document.getElementById('popupFindPwSuccessEmail');
const popupSingUpConfirmEmail = document.getElementById('popupSingUpConfirmEmail');
const popupSnsJoinComplete = document.getElementById('popupSnsJoinComplete');

const btnsJoinActive = document.getElementById('btnJoinWrap') ? document.getElementById('btnJoinWrap').querySelectorAll('button') : '';
const goEmailLogin = document.getElementById('goEmailLogin');
const goJoinMain = document.getElementById('goJoinMain');
const goJoinKakao = document.getElementById('goJoinKakao');
const goJoinFacebook = document.getElementById('goJoinFacebook');
const goJoinNaver = document.getElementById('goJoinNaver');
const goJoinEmail = document.getElementById('goJoinEmail');
const checkAgreeJoin = document.getElementById('checkAgreeJoin');

const loginInputboxes = document.getElementsByClassName('join-style-popup-input-box__input');

// 전역 변수들
const deviceOS = getInfoOfDeviceOS();
const clientID = getClientID();

const now = new Date();
const year = now.getFullYear();
const month = String(now.getMonth() + 1).padStart(2, '0');
const day = String(now.getDate()).padStart(2, '0');
const nowDate = `${year}-${month}-${day}`;

let isCheckedEmailAgreeTerms = false;
let isValidEmail = false;
let isValidPw = false;
let isValidPwCheck = false;

// 로그인 페이지 전용 변수들
const loginPage = localStorage.login ? JSON.parse(localStorage.login) : {};

// 버튼을 클릭해서 내담자일 경우 제목과 플레이스 홀더 바꾸기
const findPwPlaceholderName = [
  '닉네임을 입력해주세요.',
  '아이디를 입력해주세요.',
];

// 이제 HTML은 index.php에서 미리 정의되므로 HTML 문자열 변수들은 필요 없음

// Input 활성화 UI 설정
const setInputActiveUi = () => {
  // 로그인/회원가입 input is-focus
  if (document.getElementsByClassName('join-style-popup-input-box__input')[0]) {
    const loginInputboxesLen = loginInputboxes.length;

    for (let i = 0; i < loginInputboxesLen; i += 1) {
      loginInputboxes[i].addEventListener('keyup', (e) => {
        e.target.classList.add('is-focus');
      });

      loginInputboxes[i].addEventListener('blur', (e) => {
        e.target.classList.remove('is-focus');
      });
    }
  }
};

// 팝업 팩토리 - 각 팝업을 함수로 정의
const createPopupHandler = (popupId, eventSetup) => {
  const popup = document.getElementById(popupId);
  let eventHandlers = [];

  const addEvent = (selector, event, handler) => {
    const element = typeof selector === 'string' ? document.getElementById(selector) : selector;
    if (element) {
      element.addEventListener(event, handler);
      eventHandlers.push({ element, event, handler });
    }
  };

  const removeEvents = () => {
    eventHandlers.forEach(({ element, event, handler }) => {
      element.removeEventListener(event, handler);
    });
    eventHandlers = [];
  };

  return {
    open() {
      if (!popup) return;

      popup.classList.add('is-show');
      document.documentElement.classList.add('is-disabled-scroll');

      // 이벤트 설정
      if (eventSetup) eventSetup(addEvent);

      // 공통 닫기 이벤트
      popup.querySelectorAll('.js-popup-bg-close, .js-popup-btn-close')
        .forEach((el) => addEvent(el, 'click', this.close));
    },

    close() {
      if (!popup) return;

      popup.classList.remove('is-show');
      document.documentElement.classList.remove('is-disabled-scroll');
      removeEvents();
    },
  };
};

// 팝업 공통 함수 (하위 호환성을 위해 유지)
// 단순 팝업 (이벤트 없는) 팝업에 사용
const popupClose = (popupTarget) => {
  popupTarget.classList.remove('is-show');
  document.documentElement.classList.remove('is-disabled-scroll');
};
const popupOpen = (popupTarget) => {
  popupTarget.classList.add('is-show');
  document.documentElement.classList.add('is-disabled-scroll');

  // 팝업 배경, 닫기 버튼 누르면 닫히는 로직 추가
  popupTarget.querySelectorAll('.js-popup-bg-close, .js-popup-btn-close')
    .forEach((el) => {
      el.addEventListener('click', () => {
        popupClose(popupTarget);
      });
    });
};

// 각 팝업 핸들러 정의 - 팩토리 패턴 사용

const loginEmailPopup = createPopupHandler('popupLoginEmail', (on) => {
  on('btnLoginEmail', 'click', () => {
    emailSignIn();
  });

  on('userEmailLogin', 'keyup', (event) => {
    enterkeyLogin(event);
  });

  on('userPwLogin', 'keyup', (event) => {
    enterkeyLogin(event);
  });

  on('gofindPw', 'click', () => {
    loginEmailPopup.close();
    findPwPopup.open();
  });

  on('goJoinMain2', 'click', () => {
    loginEmailPopup.close();
    popupOpen(popupJoin);
  });
});

const findPwPopup = createPopupHandler('popupFindPw', (on) => {
  // 초기화 로직
  initializeFindPwPopup();

  on('btnFindPw', 'click', () => {
    setFindPassword(
      document.getElementById('inputNameOfFindPw'),
      document.getElementById('inputEmailOfFindPw'),
    );
  });

  on('goLoginMain4', 'click', () => {
    findPwPopup.close();
  });

  on('inputNameOfFindPw', 'blur', (event) => {
    enterkeyPasswordFind(
      document.getElementById('inputNameOfFindPw'),
      document.getElementById('inputEmailOfFindPw'),
      event,
    );
  });

  on('inputEmailOfFindPw', 'blur', (event) => {
    enterkeyPasswordFind(
      document.getElementById('inputNameOfFindPw'),
      document.getElementById('inputEmailOfFindPw'),
      event,
    );
  });

  // 라디오 버튼 이벤트
  document.getElementsByName('findPwId').forEach((radio) => {
    on(radio, 'click', () => {
      if (radio.checked) {
        document.getElementById('headNameOfFindPw').innerText = radio.value;
        document.getElementById('inputNameOfFindPw').value = '';
        document.getElementById('inputEmailOfFindPw').value = '';

        if (radio.value === '내담자') {
          document.getElementById('inputNameOfFindPw').placeholder = findPwPlaceholderName[0];
          document.getElementById('inputNameOfFindPw').name = 'nickName';
        } else if (radio.value === '상담사') {
          document.getElementById('inputNameOfFindPw').placeholder = findPwPlaceholderName[1];
          document.getElementById('inputNameOfFindPw').name = 'id';
        }
      }
    });
  });
});

const snsJoinPopup = createPopupHandler('popupSnsJoin', (on) => {
  on('goLoginMain3', 'click', () => {
    snsJoinPopup.close();
  });
});

const emailJoinPopup = createPopupHandler('popupEmailJoin', (on) => {
  on('submitSignUpEmail', 'click', () => {
    const submitBtn = document.getElementById('submitSignUpEmail');
    if (submitBtn) submitBtn.style.pointerEvents = 'none';
    emailSignUp();
  });

  on('checkboxEmailAgreeTerms', 'click', (event) => {
    isCheckedEmailAgreeTerms = (event.target.checked === true);
  });

  on('goLoginMain2', 'click', () => {
    emailJoinPopup.close();
  });

  on('userEmail', 'blur', () => {
    const userEmail = document.getElementById('userEmail');
    if (userEmail) emailIsValid(userEmail, validateEmail(userEmail.value));
  });

  on('btnOverlapCheckEmail', 'click', () => {
    const userEmail = document.getElementById('userEmail');
    if (userEmail) emailIsValid(userEmail, validateEmail(userEmail.value));
  });

  on('inputJoinNickName', 'blur', () => {
    const inputJoinNickName = document.getElementById('inputJoinNickName');
    const nicknameCheckMsg = document.getElementById('nicknameCheckMsg');
    if (inputJoinNickName) {
      nicknameIsValid(inputJoinNickName, validateNickname(inputJoinNickName.value), nicknameCheckMsg);
    }
  });

  on('btnOverlapCheckNickname', 'click', () => {
    const inputJoinNickName = document.getElementById('inputJoinNickName');
    const nicknameCheckMsg = document.getElementById('nicknameCheckMsg');
    if (inputJoinNickName) {
      nicknameIsValid(inputJoinNickName, validateNickname(inputJoinNickName.value), nicknameCheckMsg);
    }
  });

  on('userPw', 'blur', () => {
    const userPw = document.getElementById('userPw');
    if (userPw) pwIsValid(userPw, validatePassword(userPw.value));
  });

  on('userPwCheck', 'blur', () => {
    const userPwCheck = document.getElementById('userPwCheck');
    if (userPwCheck) pwCheckIsValid(userPwCheck);
  });
});

const signUpConfirmEmailPopup = createPopupHandler('popupSingUpConfirmEmail', (on) => {
  on('BtnMailConfirm', 'click', () => {
    signUpConfirmEmailPopup.close();
    popupOpen(document.getElementById('popupSingUpConfirmEmailRe'));
  });
});

// 회원가입 정규식
const validatePassword = (pw) => /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*?()_~])[A-Za-z\d!@#$%^&*?()_~]{6,14}$/.test(pw);
const validateNickname = (nickname) => /^[a-zA-Zㄱ-힣0-9]{2,8}$/.test(nickname);

// 1개 이상의 숫자 포함
const validateNumber = (text) => /[0-9]/.test(text);

// 1개 이상의 영문 포함
const validateEnglish = (text) => /[A-Za-z]/.test(text);

// 비밀번호 특수문자 포함
const validatePwSpacial = (name) => /[!@#$%^&*?()_~]/gi.test(name);

// 이메일 회원가입 버튼 활성화 검사
const sendEmailJoin = () => {
  const submitSignUpEmail = document.getElementById('submitSignUpEmail');
  // 만들어둔 모든 Valid 가 True 인지 검사
  if ((isValidEmail === true) && (isValidPw === true) && (isValidPwCheck === true)) {
    // 버튼 활성화, 버튼 클릭시 이동
    if (submitSignUpEmail) submitSignUpEmail.classList.add('is-active');
    if (submitSignUpEmail) submitSignUpEmail.disabled = false;
  } else {
    // 버튼 비활성화
    if (submitSignUpEmail) submitSignUpEmail.classList.remove('is-active');
    if (submitSignUpEmail) submitSignUpEmail.disabled = true;
  }
};

// 이메일 유효성 & 중복검사 진행 - 이메일 회원가입
const emailIsValid = (element, isValid) => {
  const eleValue = element.value;
  const isNotEmpty = (eleValue !== '' || eleValue !== null);
  if (eleValue) {
    if (isValid && isNotEmpty) {
      // 중복검사
      requestGET(`${OLD_API_URL}/sign/?type=isExistEmail&email=${eleValue}`, (status, resData) => {
        if (status) {
          if (resData.result === true) {
            document.getElementById('emailMsg').innerHTML = `<p class="join-style-popup-input-box__bottom--info-list">${resData.message}</p>`;
            isValidEmail = true;
          } else {
            document.getElementById('emailMsg').innerHTML = `<p class="join-style-popup-input-box__bottom--info-list is-error">${resData.message}</p>`;
          }
        }
      });
    } else {
      isValidEmail = false;
      document.getElementById('emailMsg').innerHTML = '<p class="join-style-popup-input-box__bottom--info-list is-error">올바른 이메일을 입력해주세요.</p>';
    }
  } else {
    document.getElementById('emailMsg').innerHTML = '<p class="join-style-popup-input-box__bottom--info-list">수신 가능한 이메일을 입력해주세요. 최초 인증 및 비밀번호 분실시 안내 메일이 발송됩니다.</p>';
  }
  sendEmailJoin();
};

// 패스워드 유효성 검사 진행 함수
const pwIsValid = (el, isValid) => {
  const eleValue = el.value;
  if (eleValue) {
    if (isValid) {
      isValidPw = true;
      document.getElementById('pwMsg').innerHTML = '';
    } else {
      isValidPw = false;
      document.getElementById('pwMsg').innerHTML = '<p class="join-style-popup-input-box__bottom--info-list is-error">영문, 숫자, 특수문자를 조합하여 6~14자 이내로 작성해주세요.</p><p class="join-style-popup-input-box__bottom--info-list">사용 가능한 특수문자 !@#$%^&*?()_~</p>';

      if (validateNumber(el.value) === false) {
        alert('숫자를 같이 조합해주세요!');
        return false;
      }
      if (validateEnglish(el.value) === false) {
        alert('영문을 같이 조합해주세요!');
        return false;
      }
      if (validatePwSpacial(el.value) === false) {
        alert('사용 가능한 특수문자를 같이 조합해주세요!');
        return false;
      }
    }
  } else {
    document.getElementById('pwMsg').innerHTML = '<p class="join-style-popup-input-box__bottom--info-list">6~14자 이내로 영문, 숫자, 특수문자를 조합하여 작성합니다.</p><p class="join-style-popup-input-box__bottom--info-list">사용 가능한 특수문자 !@#$%^&*?()_~</p>';
  }
  sendEmailJoin();
};

// 비밀번호 확인 유효성 검사
const pwCheckIsValid = (el) => {
  const eleValue = el.value;
  if (eleValue) {
    if (document.getElementById('userPw').value === document.getElementById('userPwCheck').value) {
      isValidPwCheck = true;
      document.getElementById('pwCheckMsg').innerHTML = '';
    } else {
      isValidPwCheck = false;
      document.getElementById('pwCheckMsg').innerHTML = '<p class="join-style-popup-input-box__bottom--info-list is-error">입력하신 비밀번호가 일치하지 않습니다.</p>';
    }
  } else {
    document.getElementById('pwCheckMsg').innerHTML = '<p class="join-style-popup-input-box__bottom--info-list">비밀번호를 재확인 합니다.</p>';
  }
  sendEmailJoin();
};

// 닉네임 검사 - input의 value값이 없을 때, placeholder로 제시한 값을 value값으로 넘
const nicknameIsValid = (el, isValid, msgEl) => {
  if (el.value) {
    if (isValid) {
      requestGET(`${OLD_API_URL}/sign/?type=isExistNickname&name=${el.value}`, (status, resData) => {
        if (status) {
          if (resData.result === true) {
            msgEl.innerHTML = `<p class="join-style-popup-input-box__bottom--info-list">${resData.message}</p>`;
          } else {
            msgEl.innerHTML = '<p class="join-style-popup-input-box__bottom--info-list is-error">이미 사용 중인 닉네임입니다.</p>';
          }
        }
      });
    } else {
      msgEl.innerHTML = '<p class="join-style-popup-input-box__bottom--info-list is-error">닉네임은 2~8자로 작성해주세요. 특수문자 사용할 수 없습니다.</p>';
    }
  } else {
    // 랜덤 닉네임은 중복검사를 별도로 함.
    el.value = el.placeholder;
    msgEl.innerHTML = '<p class="join-style-popup-input-box__bottom--info-list">닉네임은 상담 시 사용되는 이름으로 가입 후 수정이 불가합니다.</p>'
      + '<p class="join-style-popup-input-box__bottom--info-list">자동으로 입력된 닉네임은 가입완료 전에 수정이 가능합니다.</p>';
  }
};

const randomItem = (items) => items[Math.floor(Math.random() * items.length)];
let randomNickname = '';
let overlapCheckNum = 0;

// 닉네임 중복검사 - 재귀 알고리즘
const setNicknameCheck = (nickname, el) => {
  requestGET(`${OLD_API_URL}/sign/?type=isExistNickname&name=${nickname}`, (status, resData) => {
    if (status) {
      if (resData.result) {
        el.placeholder = nickname;
        return true;
      }

      if (resData.result === false) {
        if (overlapCheckNum < 2) {
          // 중복일 경우 랜덤닉네임 다시 요청 (3번까지만 중복체크)
          requestPOST(`${OLD_API_URL}/sign/`, {
            type: 'randomNickname',
          }, (restatus, reresData) => {
            if (restatus) {
              setNicknameCheck((randomItem(reresData.data.randomFirstNickname) + randomItem(reresData.data.randomLastNickname)), el);
            }
            overlapCheckNum += 1;
          });
        } else {
          return false;
        }
      }
    }
  });
};

// 랜덤닉네임
const setRandomNickname = (el) => {
  // 매번 새로 호출될 때 중복체크 카운터 초기화
  overlapCheckNum = 0;
  requestPOST(`${OLD_API_URL}/sign/`, {
    type: 'randomNickname',
  }, (status, resData) => {
    if (status) {
      randomNickname = randomItem(resData.data.randomFirstNickname) + randomItem(resData.data.randomLastNickname);
      // 닉네임 중복검사
      setNicknameCheck(randomNickname, el);
    }
  });
};

// 이메일 로그인
const emailSignIn = (reqEmail = '', reqPw = '') => {
  const userEmail = reqEmail || document.getElementById('userEmailLogin').value;
  const userPw = reqPw || document.getElementById('userPwLogin').value;

  if (userEmail && userPw) {
    if (document.getElementById('loader')) {
      document.getElementById('loader').style.display = 'block';
    }

    clearLocalStorageItem('auth');
    clearLocalStorageItem('userID');
    clearLocalStorageItem('userName');

    const reqData = {
      type: 'sign',
      email: userEmail,
      password: userPw,
      appToken: '',
    };

    requestPOST(`${OLD_API_URL}/sign/`, reqData, (status, resData) => {
      if (!status) {
        alert(resData.message);
        return false;
      }

      if (document.getElementById('loader')) {
        document.getElementById('loader').style.display = 'none';
      }

      if (resData.result) {
        popupClose(popupLoginEmail);

        clearLocalStorageItem('auth');
        clearLocalStorageItem('userID');
        if (!reqEmail && !reqPw) alert(resData.message);
        setJWTTokenData(resData);
        setJWTUserData(resData);

        localStorage.setItem('userName', resData.data.userName);

        localStorage.setItem('writePillReviewSignIn', true);

        if (localStorage.isFinishWriteReview) {
          const { reviewID } = JSON.parse(localStorage.isFinishWriteReview);
          localStorage.setItem('writeReviewGetCoupon', JSON.stringify({ reviewID }));
        }

        // localStorage에서 accessToken 가져오기
        const auth = localStorage.getItem('auth');
        const accessToken = auth ? JSON.parse(auth).data.accessToken.token : '';

        window.location.href = `/auth/sign/?status=${resData.data.userStatus}&userName=${resData.data.userName}&userID=${resData.data.userID}&signToken=${resData.data.signToken}&levelBadge=${resData.data.levelBadge}&accessToken=${accessToken}`;
      } else {
        document.getElementById('loginMsg').innerHTML = '<p class="join-style-popup-input-box__bottom--info-error">계정 또는 비밀번호가 일치하지 않습니다.</p>';
      }
    });
  } else if (!userEmail) {
    alert('이메일 아이디를 입력해주세요.');
  } else if (!userPw) {
    alert('비밀번호를 입력해주세요.');
  }
};

// 비밀번호 찾기
const setFindPassword = (nickNameEl, emailEl) => {
  if (document.getElementById('btnFindPw').classList.contains('is-active')) {
    const userNickNameValue = (nickNameEl.name === 'nickName') ? nickNameEl.value : '';
    const userIDValue = (nickNameEl.name === 'id') ? nickNameEl.value : '';

    const reqData = {
      type: 'setNewPassword',
      userID: userIDValue,
      userEmail: emailEl.value,
      userNickname: userNickNameValue,
    };

    requestPOST(`${OLD_API_URL}/sign/`, reqData, (status, resData) => {
      if (status && resData.result) {
        popupOpen(popupFindPwSuccessEmail);
        popupClose(popupFindPw);
        document.getElementById('emailOfFindPw').innerText = emailEl.value;
      } else {
        alert(resData.message);
      }
    });
  } else if (!document.getElementById('inputNameOfFindPw').value) {
    alert('닉네임 또는 (상담사의 경우) 아이디를 입력해주세요.');
  } else if (!document.getElementById('inputEmailOfFindPw').value) {
    alert('이메일을 입력해주세요.');
  }
};

// SNS 로그인
const setSNSSignIn = (signType, accessToken) => {
  const reqData = {
    type: 'sign_sns',
    snsType: signType,
    accessToken,
    appToken: '',
  };

  clearLocalStorageItem('auth');
  clearLocalStorageItem('userID');
  clearLocalStorageItem('userName');

  requestPOST(`${OLD_API_URL}/sign/`, reqData, (resStatus, resData) => {
    if ((!resStatus) || (!resData)) {
      alert("잘못된 접근 입니다, 이용에 어려움이 있으시면 카카오톡 플러스친구 '@트로스트' 로 문의 주세요!");
      window.location.reload();
      return false;
    }

    if (resData.data.userName) {
      if (resData.result) {
        popupClose(popupLoginEmail);

        setJWTTokenData(resData);
        setJWTUserData(resData);
        localStorage.setItem('userName', resData.data.userName);

        // localStorage에서 accessToken 가져오기
        const auth = localStorage.getItem('auth');
        const accessTokenParam = auth ? JSON.parse(auth).data.accessToken.token : '';

        window.location.href = `/auth/sign/?status=client&userName=${resData.data.userName}&userID=${resData.data.userID}&signToken=${resData.data.signToken}&type=${signType}&accessToken=${accessTokenParam}`;
      } else {
        document.getElementById('loginMsg').innerHTML = '<p class="join-style-popup-input-box__bottom--info-error">계정 또는 비밀번호가 일치하지 않습니다.</p>';
      }
    } else {
      if (!resData.result) {
        alert(resData.message);
        window.location.href = '/';
        return false;
      }

      // 회원가입
      snsJoinPopup.open();
      popupClose(popupJoin);

      // 랜덤닉네임 - 약간의 지연을 줘서 DOM 렌더링 완료 후 실행
      setTimeout(() => {
        const nickNameElement = document.getElementById('js-inputNickName');
        if (nickNameElement) {
          setRandomNickname(nickNameElement);
        }
      }, 100);

      document.getElementById('js-inputNickName').addEventListener('blur', () => {
        nicknameIsValid(document.getElementById('js-inputNickName'), validateNickname(document.getElementById('js-inputNickName').value), document.getElementById('nicknameCheckMsgOfSnsJoin'));

        if (document.getElementById('js-inputNickName').value) {
          document.getElementById('submitSignUpSNS').classList.add('is-active');
        }
      });

      document.getElementById('btnOverlapCheckNicknameSns').addEventListener('click', () => {
        nicknameIsValid(document.getElementById('js-inputNickName'), validateNickname(document.getElementById('js-inputNickName').value), document.getElementById('nicknameCheckMsgOfSnsJoin'));
      });

      document.getElementById('submitSignUpSNS').onclick = () => {
        if (document.getElementById('js-inputNickName').value) {
          document.getElementById('submitSignUpSNS').classList.add('is-active');
        }

        if (document.getElementById('submitSignUpSNS').classList.contains('is-active')) {
          setSNSSignUp(resData.data.userID, { status: signType, accessToken });
        }
      };
    }
  });
};

// SNS 회원가입
const setSNSSignUp = (userID, snsResData) => {
  const reqData = {
    type: 'addNewName',
    emailAgreeTerms: document.getElementById('checkboxSnsAgreeTerms').checked ? 1 : 0,
    id: userID,
    programCode: document.getElementById('js-inputJoinRecProgramCode').value,
    name: document.getElementById('js-inputNickName').value,
    userOwnKey: document.getElementById('js-inputJoinRecUserCode').value,
  };

  requestPOST(`${OLD_API_URL}/sign/`, reqData, (status, resData) => {
    if (!status || !resData.result) {
      const alertMsg = resData.message || "잘못된 접근 입니다, 이용에 어려움이 있으시면 카카오톡 플러스친구 '@트로스트' 로 문의 주세요!";
      alert(alertMsg);
      window.location.reload();
      return false;
    }

    webkitBridgeWebviewFirebaseUserProperty({ type: 'set', userPropertyKey: '회원유형', userPropertyValue: 'personal' });
    webkitBridgeWebviewFirebaseUserProperty({ type: 'set', userPropertyKey: '가입일', userPropertyValue: nowDate });

    // 회원가입(SNS) - 구글 전환 추적 전송
    // gtag('event', 'conversion', { send_to: 'AW-951599716/Py-yCJjE2mUQ5IThxQM' });
    const loginData = localStorage.login ? JSON.parse(localStorage.login) : {};
    if (loginData) {
      const refererUrl = loginData.referer && loginData.referer.indexOf('?') !== -1 ? `${loginData.referer}&signSNSReferer=true` : `${loginData.referer}?signSNSReferer=true`;
      localStorage.setItem('signData', JSON.stringify({ type: 'mobile' }));
      localStorage.setItem('login', JSON.stringify({ referer: refererUrl }));
      clearLocalStorageItem('loadPage');
    } else {
      localStorage.setItem('signData', JSON.stringify({ type: 'mobile' }));
      localStorage.setItem('login', JSON.stringify({ referer: window.location.href }));
      clearLocalStorageItem('loadPage');
    }

    setSNSSignIn(snsResData.status, snsResData.accessToken);
  });
};

// 이메일 재발송
const setSendSingUpEmail = (clientData) => {
  const reqDataSendMailAgain = {
    type: 'sendMailagain',
    id: clientData.id,
    email: clientData.email,
  };

  requestPOST(`${OLD_API_URL}/sign/`, reqDataSendMailAgain, (status, resData) => {
    if (!status || !resData.result) {
      alert(resData.message);
      return false;
    }

    return true;
  });
};

// 이메일 회원가입
const emailSignUp = () => {
  if ((!document.getElementById('inputJoinNickName').value) || (!document.getElementById('userEmail').value) || (!document.getElementById('userPw').value)) {
    alert('모든 정보를 정확하게 입력해주세요!');
    document.getElementById('submitSignUpEmail').style.pointerEvents = '';

    return false;
  }
  const idValue = (document.getElementById('userEmail').value).split('@')[0];
  const reqDataEmailSignUp = {
    type: 'sign_new',
    programCode: document.getElementById('inputJoinRecProgramCode').value,
    id: `${idValue}_${new Date().getTime()}`,
    password: document.getElementById('userPw').value,
    email: document.getElementById('userEmail').value,
    isAgreeEmailMarketingTerms: isCheckedEmailAgreeTerms,
    appToken: '',
    name: document.getElementById('inputJoinNickName').value,
    friendUserCode: document.getElementById('inputJoinRecUserCode').value,
  };

  requestPOST(`${OLD_API_URL}/sign/`, reqDataEmailSignUp, (status, resData) => {
    // 추천인코드 입력 오류체크
    // recUserCodeValid(inputJoinRecUserCode, resData);
    // recProgramCodeValid(inputJoinRecProgramCode, resData);

    document.getElementById('submitSignUpEmail').style.pointerEvents = '';

    if (resData.data.isValidWithUserEmail !== true) {
      alert('이미 사용 중인 이메일 입니다!');
      return false;
    }

    if (resData.data.isValidWithUserID !== true) {
      alert("잘못된 접근 입니다, 이용에 어려움이 있으시면 카카오톡 플러스친구 '@트로스트' 로 문의 주세요!");
      window.location.reload();
      return false;
    }

    if (resData.data.isValidWithUserName !== true) {
      alert('이미 사용 중인 닉네임 입니다!');
      return false;
    }

    if (resData.data.isValidWithFriendUserCode !== true) {
      document.getElementById('recUserCodeCheckMsg').innerHTML = '<p class="join-style-popup-input-box__bottom--info-list is-error">잘못된 추천 코드입니다.</p>';
      return false;
    }

    if (document.getElementById('recProgramCodeCheckMsg')) {
      document.getElementById('recProgramCodeCheckMsg').innerHTML = '<p class="join-style-popup-input-box__bottom--info-list">맞춤 추천 프로그램을 구입하신 분만 입력해주세요.</p>'
        + '<p class="join-style-popup-input-box__bottom--info-list">맞춤 추천 프로그램으로 구매하신 상담권은 트로스트 앱에서만 사용 가능합니다.</p>';

      document.getElementById('recUserCodeCheckMsg').innerHTML = '';
    }

    let loginReferer = '';
    if (localStorage.login) {
      if (loginPage.referer) {
        // 로그인 버튼을 눌러 진입한 경우
        loginReferer = appendQueryObject(loginPage.referer, { signEmailReferer: true });
      } else {
        loginReferer = appendQueryObject(window.location.href, { signEmailReferer: true });
      }
    } else {
      // 주소를 직접 입력해서 진입한 경우
      loginReferer = appendQueryObject('/', { signEmailReferer: true });
    }

    localStorage.setItem('login', JSON.stringify({ referer: loginReferer }));
    localStorage.setItem('signData', JSON.stringify({ type: 'mobile' }));
    localStorage.setItem('userEmail', reqDataEmailSignUp.email);
    clearLocalStorageItem('loadPage');

    emailSignIn(reqDataEmailSignUp.email, reqDataEmailSignUp.password);

    if (document.getElementById('dataJoinEmail')) {
      document.getElementById('dataJoinEmail').innerText = reqDataEmailSignUp.email;
    }

    webkitBridgeWebviewFirebaseUserProperty({ type: 'set', userPropertyKey: '회원유형', userPropertyValue: 'personal' });
    webkitBridgeWebviewFirebaseUserProperty({ type: 'set', userPropertyKey: '가입일', userPropertyValue: nowDate });

    // 회원가입(이메일) - 구글 전환 추적 전송
    // gtag('event', 'conversion', { send_to: 'AW-951599716/Py-yCJjE2mUQ5IThxQM' });

    if (document.getElementById('btnConfirmEmailRe')) {
      document.getElementById('btnConfirmEmailRe').addEventListener('click', () => {
        setSendSingUpEmail(reqDataEmailSignUp);
      });
    }
  });
};

// SNS 로그인 함수들
const setSNSSignInWithKakao = () => {
  if (!window?.Kakao || window.Kakao.isInitialized() === false) {
    return false;
  }

  window.Kakao.Auth.login({
    success: (authObj) => {
      setSNSSignIn('kakaotalk', authObj.access_token);
    },
    fail: () => {
      alert("잘못된 접근 입니다, 이용에 어려움이 있으시면 카카오톡 플러스친구 '@트로스트' 로 문의 주세요!");
      window.location.reload();
      return false;
    },
  });
};

const setSNSSignInWithNaver = () => {
  window.location.href = `https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=vsxBVHWYhpvrK16cnlvT&redirect_uri=${window.location.origin}/auth/sign/connect.php?state=${new Date().getTime()}&type=${deviceOS}`;
};

const setSNSSignInWithApple = () => {
  if (window.location.host === 'trost.co.kr' || window.location.host === 'www.trost.co.kr') {
    window.location.href = 'https://appleid.apple.com/auth/authorize?scope=email&response_type=code%20id_token&redirect_uri=https://trost.co.kr/auth/sign/apple/connect.php&state=state&client_id=humart.trost.co.kr&response_mode=form_post';
  } else {
    window.location.href = `https://appleid.apple.com/auth/authorize?scope=email&response_type=code%20id_token&redirect_uri=${window.location.origin}/auth/sign/apple/connect.php&state=state&client_id=humart.trost.co.kr&response_mode=form_post`;
  }
};

function setSNSSignInWithFacebook() {
  FB.getLoginStatus((statusResponse) => {
    if (statusResponse.status === 'connected') {
      setSNSSignIn('facebook', statusResponse.authResponse.accessToken);
    } else {
      FB.login(() => {
        FB.getLoginStatus((AgainstatusResponse) => {
          setSNSSignIn('facebook', AgainstatusResponse.authResponse.accessToken);
        }, { scope: 'public_profile,email' });
      });
    }
  }, { scope: 'public_profile,email' });
}

// 엔터키 이벤트 함수들
const enterkeyLogin = (event) => {
  if (event.key === 'Enter') {
    emailSignIn();
  }
};

const enterkeyPasswordFind = (nickNameEl, emailEl, event) => {
  if (nickNameEl.value && emailEl.value) {
    document.getElementById('btnFindPw').classList.add('is-active');
  } else {
    document.getElementById('btnFindPw').classList.remove('is-active');
  }

  if (event.key === 'Enter') {
    setFindPassword(nickNameEl, emailEl);
  }
};

// 팝업별 초기화 함수
const initializeFindPwPopup = () => {
  // 비밀번호 찾기 - default 내담자
  const findPwIdElements = document.getElementsByName('findPwId');
  if (findPwIdElements.length > 0) {
    findPwIdElements[0].checked = true;
    const headNameEl = document.getElementById('headNameOfFindPw');
    const inputNameEl = document.getElementById('inputNameOfFindPw');

    if (headNameEl) headNameEl.innerText = findPwIdElements[0].value;
    if (inputNameEl) {
      inputNameEl.placeholder = findPwPlaceholderName[0];
      inputNameEl.name = 'nickName';
    }
  }
};

// 메인 이벤트 핸들러 설정 함수
const initAuthEvents = () => {
  // 로그인/회원가입 input is-focus
  setInputActiveUi();

  // 가입 동의 체크 - 디폴트
  for (let i = 0; i < btnsJoinActive.length; i += 1) {
    checkAgreeJoin.checked = true;
    btnsJoinActive[i].classList.add('is-active');
    btnsJoinActive[i].disabled = false;
    document.getElementById('goJoinEmail').disabled = false;
  }

  // 가입하기 동의 체크 동작
  checkAgreeJoin.addEventListener('click', (e) => {
    for (let i = 0; i < btnsJoinActive.length; i += 1) {
      if (e.target.checked === true) {
        btnsJoinActive[i].classList.add('is-active');
        btnsJoinActive[i].disabled = false;
        document.getElementById('goJoinEmail').disabled = false;
      } else {
        btnsJoinActive[i].classList.remove('is-active');
        btnsJoinActive[i].disabled = true;
        document.getElementById('goJoinEmail').disabled = true;
      }
    }
  });

  // 이메일 로그인 이동
  if (goEmailLogin) {
    goEmailLogin.addEventListener('click', () => {
      loginEmailPopup.open();
    });
  }

  // 로그인에서 회원가입 이동
  if (goJoinMain) {
    goJoinMain.addEventListener('click', () => {
      popupOpen(popupJoin);
    });
  }

  // 회원가입메인에서 이메일로 회원가입 이동
  if (goJoinEmail) {
    goJoinEmail.addEventListener('click', () => {
      emailJoinPopup.open();
      popupClose(popupJoin);

      // 랜덤닉네임 - 약간의 지연을 줘서 DOM 렌더링 완료 후 실행
      setTimeout(() => {
        const nickNameElement = document.getElementById('inputJoinNickName');
        if (nickNameElement) {
          setRandomNickname(nickNameElement);
        }
      }, 100);
    });
  }

  // 로그인메인 이동(회원가입/이메일회원가입/sns회원가입/비밀번호찾기)
  if (document.getElementById('goLoginMain1')) {
    document.getElementById('goLoginMain1').addEventListener('click', () => {
      popupClose(popupJoin);
    });
  }

  if (document.getElementById('btnConfirmEmailComplete')) {
    document.getElementById('btnConfirmEmailComplete').addEventListener('click', () => {
      popupClose(document.getElementById('popupSingUpConfirmEmailComplete'));
    });
  }

  if (document.getElementById('btnPopupMsgYouthCounseling')) {
    document.getElementById('btnPopupMsgYouthCounseling').addEventListener('click', () => {
      popupOpen(document.getElementById('popupMsgYouthCounseling'));
    });
  }

  if (document.getElementById('btnClosePopupMsgYouthCounseling')) {
    document.getElementById('btnClosePopupMsgYouthCounseling').addEventListener('click', () => {
      popupClose(document.getElementById('popupMsgYouthCounseling'));
    });
  }

  // SNS 회원가입
  if (goJoinKakao) {
    goJoinKakao.addEventListener('click', () => {
      clearLocalStorageItem('auth');
      clearLocalStorageItem('userID');
      setSNSSignInWithKakao();
    });
  }

  if (goJoinFacebook) {
    goJoinFacebook.addEventListener('click', () => {
      clearLocalStorageItem('auth');
      clearLocalStorageItem('userID');
      setSNSSignInWithFacebook();
    });
  }

  if (goJoinNaver) {
    goJoinNaver.addEventListener('click', () => {
      clearLocalStorageItem('auth');
      clearLocalStorageItem('userID');
      setSNSSignInWithNaver();
    });
  }

  // SNS 로그인
  if (document.getElementById('js-login-kakao')) {
    document.getElementById('js-login-kakao').addEventListener('click', () => {
      setSNSSignInWithKakao();
    });
  }

  if (document.getElementById('js-login-facebook')) {
    document.getElementById('js-login-facebook').addEventListener('click', () => {
      setSNSSignInWithFacebook();
    });
  }

  if (document.getElementById('js-login-naver')) {
    document.getElementById('js-login-naver').addEventListener('click', () => {
      setSNSSignInWithNaver();
    });
  }

  if (document.getElementById('js-login-apple')) {
    document.getElementById('js-login-apple').addEventListener('click', () => {
      setSNSSignInWithApple();
    });
  }
};

// DOM이 로드되면 이벤트 핸들러 초기화
window.addEventListener('DOMContentLoaded', () => {
  /**
   * SNS 모듈 초기화
   */
  try {
    if (window?.Kakao && window.Kakao.isInitialized() === false) {
      window.Kakao?.init('dc8e8076aadd8e1484c3a404e98d63c7');
    }
  } catch (error) {
    console.error('Kakao SDK 초기화 중 에러가 발생했습니다: ', error);
  }

  try {
    window.fbAsyncInit = () => {
      FB.init({
        appId: '648514988614114',
        cookie: true,
        xfbml: true,
        version: 'v3.2',
      });
      FB.AppEvents.logPageView();
    };

    ((d, s, id) => {
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      const js = d.createElement(s);
      js.id = id;
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
  } catch (error) {
    console.error('Facebook SDK 초기화 중 에러가 발생했습니다: ', error);
  }

  // 쿼리스트링 처리
  if (getQuerystring('signSNSReferer') === 'true' && clientID) {
    popupOpen(popupSnsJoinComplete);
    snsJoinPopup.close();

    if (document.getElementById('snsJoinNickname')) {
      document.getElementById('snsJoinNickname').innerText = localStorage.userName;
    }
  }

  if (getQuerystring('signEmailReferer') === 'true' && clientID) {
    signUpConfirmEmailPopup.open();

    if (document.getElementById('dataJoinEmail')) {
      document.getElementById('dataJoinEmail').innerText = localStorage.userEmail;
    }
  }

  if (window.location.href === `${window.location.origin}/?type=signup_finish`) {
    popupOpen(document.getElementById('popupSingUpConfirmEmailComplete'));
  }

  if ((getQuerystring('signAuth') === 'true') && (getQuerystring('userEmail'))) {
    popupOpen(document.getElementById('popupSingUpConfirmEmailComplete'));
    document.getElementById('confirmEmail').innerText = getQuerystring('userEmail');
    popupClose(popupSingUpConfirmEmail);
  }

  if (getQuerystring('signAuth')) {
    if (!getQuerystring('accessToken')) {
      alert("잘못된 접근 입니다, 이용에 어려움이 있으시면 카카오톡 플러스친구 '@트로스트' 로 문의 주세요!");
      window.location.reload();

      return false;
    }

    if (getQuerystring('signAuth') === 'naver') {
      setSNSSignIn('naver', getQuerystring('accessToken'));
    } else if (getQuerystring('signAuth') === 'apple') {
      setSNSSignIn('apple', getQuerystring('accessToken'));
    }
  }

  // 모네플-트로스트에서 트로스트 로그인 페이지 접근 시 로그인 완료 후 redirectUri 처리
  if (getQuerystring('redirectUri')) {
    localStorage.setItem('login', JSON.stringify({ referer: getQuerystring('redirectUri') }));
  }

  // 이벤트 핸들러 초기화
  initAuthEvents();
});
